// extracted by mini-css-extract-plugin
module.exports = {"root":"u1aaKT1ybNXnnUt5E6oA"};